module.exports = __webpack_public_path__ + "static/img/plate.399c875.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/s29/pop/plate.png
// module id = 91M4
// module chunks = 2